export default "__VITE_ASSET__DnmJSqS$__"